<script>
    import { Link } from 'svelte-routing';
    import {store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import Header from '../components/Header.svelte';
    import Image from '../components/Image.svelte';

    const user = store('credentials', 'appUserAuth');
</script>

<TopMenu title="Нет доступа 🤕" />

<div id="appCapsule">
    <div class="error-page">
        <Image src="/img/vector3.png" alt="image" class="imaged square w200" />
        <h1 class="title">Нет доступа 🤕</h1>
        <div class="text mb-5">
            Что-то пошло не так, такой страницы у нас нет
    
            {#if $user.idRegPred > 0}
                <p class="text mt-3">
                    Возможно вы пытаетесь просмотреть страницу доступную только участникам.
                </p>
            {/if}
        </div>
        
        <div class="fixed-footer">
            <div class="row">
                <div class="col-12">
                    <a href="/" class="btn btn-primary btn-lg btn-block">Вернитесь</a>
                </div>
            </div>
        </div>
    </div>
</div>
